import { ensureCsrfToken, getCsrfToken } from './csrf';

// Ends the current allauth browser session by submitting a real POST form to
// /accounts/logout/. A form (rather than fetch) lets the browser follow the
// configured LOGOUT_REDIRECT_URL with a full page reload, which clears any
// in-memory React state for the signed-out user.
export async function signOut(): Promise<void> {
  const token = getCsrfToken() || (await ensureCsrfToken());

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/accounts/logout/';

  const csrfInput = document.createElement('input');
  csrfInput.type = 'hidden';
  csrfInput.name = 'csrfmiddlewaretoken';
  csrfInput.value = token;
  form.appendChild(csrfInput);

  document.body.appendChild(form);
  form.submit();
}
